/**
 * Readable title from a machine key. `aptitude_grade-9` → `Aptitude Grade 9`.
 *
 * Used when an API returns only a slug so the raw key never reaches the
 * screen. Falls back to `fallback` when the key has no words.
 */
export function humaniseKey(key: string | null | undefined, fallback: string): string {
  const words = (key ?? "").split(/[_\-\s]+/).filter(Boolean);
  if (words.length === 0) return fallback;
  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}

/**
 * Prefer a human name. When it is missing or blank, build a title from
 * the machine key via {@link humaniseKey}.
 */
export function nameOrKeyTitle(
  name: string | null | undefined,
  key: string | null | undefined,
  fallback: string,
): string {
  const trimmed = name?.trim() ?? "";
  if (trimmed.length > 0) return trimmed;
  return humaniseKey(key, fallback);
}
